module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/bonds-large.RU.262438e3.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/bonds-large.RU.png
// module id = 2666
// module chunks = 11